import {
  Select as SelectBase,
  MenuItem as MenuItemBase,
  FormControl as FormControlBase,
  listClasses,
  paperClasses,
  svgIconClasses,
  selectClasses,
  styled,
} from '@mui/material'

import { getTextFieldStyles } from '../../utils/shared/TextField'

export const FormControl = styled(FormControlBase)(({ theme }) => {
  return {
    ...getTextFieldStyles({ theme }),

    [`& .${selectClasses.select}`]: {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },

    [`& .${svgIconClasses.root}.${selectClasses.icon}.${selectClasses.iconOutlined}`]: {
      zIndex: 2,
    },

    [`& .${paperClasses.root}`]: {
      maxHeight: 48 * 4.5,
      borderRadius: '0px 0px 4px 4px',
    },

    [`& .${listClasses.root}`]: {
      padding: 0,
    },
  }
})

export const MenuItem = styled(MenuItemBase)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  fontSize: theme.spacing(2),

  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}))

export const Select = styled(SelectBase)({})
